export function animateProgressBar(currentStep) {

    let stepAmount = cloudmanufaktur.stepAmount;
    let progressBar = document.querySelector("#progress-bar .progress");

    let progressBarWidth = 100 / stepAmount * currentStep;

    progressBar.style.width = progressBarWidth + '%'

}